/* src/app/component/mark-disable/mark-disable.component.scss */
.mark-disable-wrapper {
  border-radius: 12px;
  background-color: #fff;
}
.mark-disable-wrapper p {
  margin-top: 0px;
  font-size: 14px;
  color: #344054;
  font-weight: 400;
  line-height: 20px;
}
.summary-box {
  padding: 20px;
  border-radius: 12px;
  background-color: #F2F4F7;
  margin-bottom: 24px;
}
.summary-box h3 {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
}
.summary-box .location {
  font-size: 14px;
  color: #666;
}
.summary-box .stats {
  display: flex;
  margin-top: 12px;
  gap: 80px;
}
.summary-box .stats label {
  font-size: 12px;
  color: #999;
}
.summary-box .stats p {
  font-weight: 600;
  margin: 4px 0 0;
}
.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
}
.dropdown-item .name {
  font-weight: 500;
}
.dropdown-item .location {
  font-size: 12px;
  color: #777;
}
.p-dropdown {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}
.p-dropdown-label {
  padding: 10px;
}
.dialog-footer {
  margin-top: 20px;
  text-align: right;
}
.form-group {
  border: 1px dashed #E4E7EC;
  padding: 20px;
  background: #F9FAFB;
  border-radius: 12px;
}
.form-group label {
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  margin-bottom: 6px;
}
.btn {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  height: 40px;
}
.btn-cancel {
  background-color: white;
  color: #000;
  border: 1px solid #D0D5DD;
  margin-right: 12px;
}
.btn-cancel:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffecd9;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #ff8c00;
  margin-right: 15px;
}
::ng-deep .p-dropdown-panel {
  max-height: 220px !important;
  border-radius: 12px !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
}
::ng-deep .p-scroller {
  border-radius: 12px;
  overflow-x: auto;
  overflow-y: auto;
}
/*# sourceMappingURL=mark-disable.component-7ALC5VMI.css.map */
